import { func, object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ApiImg, Icon } from 'components';
import { capitalizeFirstLetter, formatLocalizedCurrency } from 'helpers';

const LeisurePromote = ({ promote, goToProductSow }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full rounded-lg shadow-lg overflow-hidden relative">
      <button type="button" className="opacity-0 absolute inset-0" onClick={goToProductSow}>
        {t('products:productShowCta', { title: promote?.title || '' })}
      </button>

      <div className="aspect-square overflow-hidden shrink-0 sm:aspect-video">
        <ApiImg src={promote.vignette} />
      </div>

      <div className="flex flex-col p-6 grow">
        <h3 className="h3 text-xl truncate-line three-lines">{promote.title}</h3>
        {promote.categoryLabel && <h4 className="text-gray-600">{capitalizeFirstLetter(promote.categoryLabel)}</h4>}

        <div className="grow flex flex-col justify-center h-32">
          <p>
            <span>{t('fromPrice')}</span>
            <span className="text-secondary-500 mx-1 text-xl font-medium">
              {formatLocalizedCurrency(promote.price, {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                style: 'currency',
                currency: 'EUR'
              })}
            </span>
          </p>
        </div>

        <div className="flex justify-between items-start">
          <div className="flex gap-2 items-center">
            {(promote.country || promote.city) && (
              <Icon name="location-dot" iconStyle="fad" classes="text-primary-500" />
            )}
            <p className="capitalize">
              {`${promote.country ?? ''}${promote.country && promote.city ? ',' : ''} ${promote.city ?? ''}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

LeisurePromote.propTypes = {
  promote: object.isRequired,
  goToProductSow: func.isRequired
};

export default LeisurePromote;
